import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Flex } from '@zillow/constellation';

import ConnectedNetworkView from 'app/shared/components/ConnectedNetworkView';
import PropertyConstants from 'app/shared/constants/PropertyConstants';
import { PropertiesSelectors } from 'app/shared/selectors';

import {
    StyledFlexPriceOnlyContainer,
    StyledPriceTag,
    StyledMobileOnlyVerticalDivider,
    StyledVerticalDivider,
    StyledWeek,
} from './StyledComponents';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

const propTypes = {
    isFree: PropTypes.bool.isRequired,
    isInPaidMarket: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isPaidMultifamily: PropTypes.bool.isRequired,
    lengthOfTime: PropTypes.string,
    price: PropTypes.string.isRequired,
    syndication: PropTypes.object.isRequired,
};

const defaultProps = {
    lengthOfTime: 'week',
};

const AdditionalInformation = ({
    isFree,
    isInPaidMarket,
    isMobile,
    isScreenTablet,
    lengthOfTime,
    price,
    syndication,
    isPaidMultifamily,
}) => {
    const { overview: { status } } = syndication;
    const {
        leadGuarantee: {
            isEligible: isEligibleForLeadGuarantee,
        },
    } = useSelector(state => PropertiesSelectors.makeCurrentProperty(state));
    const showPrice = (isInPaidMarket || isEligibleForLeadGuarantee) && !isPaidMultifamily;

    const renderPriceComponent = () => {
        if (isFree) {
            return null;
        }
        return (
            <StyledFlexPriceOnlyContainer>
                <Flex display="flex">
                    <StyledPriceTag>{price}</StyledPriceTag>
                    &nbsp;
                    <StyledWeek as="span">
                        {`/${lengthOfTime}`}
                    </StyledWeek>
                </Flex>
                <StyledMobileOnlyVerticalDivider />
            </StyledFlexPriceOnlyContainer>
        );
    };

    if (status === SYNDICATION_OVERVIEW_STATUS.DECLINED) {
        return null;
    }

    if ((status === SYNDICATION_OVERVIEW_STATUS.PUBLISHED && !isMobile && showPrice)) {
        return renderPriceComponent();
    }

    if ((status === SYNDICATION_OVERVIEW_STATUS.PUBLISHING && !isMobile && showPrice)) {
        return renderPriceComponent();
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.PARTIALLY_PUBLISHED) {
        return (
            <Flex display="flex" alignItems="center" flexGrow={1}>
                <StyledVerticalDivider />
                <ConnectedNetworkView
                    syndication={syndication}
                    label={`View published ${isMobile ? '' : 'listings'}`}
                />
                {showPrice && !isMobile && !isScreenTablet && renderPriceComponent()}
            </Flex>
        );
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.INACTIVE && showPrice) {
        return renderPriceComponent();
    }

    return null;
};

AdditionalInformation.propTypes = propTypes;
AdditionalInformation.defaultProps = defaultProps;

export default AdditionalInformation;
